export default __webpack_public_path__ + "static/media/pay.65ee5366.png";